import React from 'react'
import './counter.css'

const Counter = ({data}) => {
    return (
        <>
            <section className='counter_section'>
                <div className="container">
                    <div className='counter-bg'>
                        <div className='row rowwidth'>
                            <div className='col-lg-3 col-sm-6 col-6 mb-3'>
                                <div className='counter-box bd-right'>
                                    <h2 className='number'>{data?.users}+</h2>
                                    <p className='text'>Happy <br></br> Customer</p>
                                </div>
                            </div>
                            <div className='col-lg-3 col-sm-6 col-6 mb-3 '>
                                <div className='counter-box bd-right'>
                                    <h2 className='number'>{data?.product}+</h2>
                                    <p className='text'>Fresh<br></br>Products</p>
                                </div>
                            </div>
                            <div className='col-lg-3 col-sm-6 col-6 mb-3'>
                                <div className='counter-box '>
                                    <h2 className='number'>{data?.review}+</h2>
                                    <p className='text'>Client <br></br>Review</p>
                                </div>
                            </div>
                            <div className='col-lg-3 col-sm-6 col-6 mb-3'>
                                <div className='counter-box'>
                                    <h2 className='number'>20+</h2>
                                    <p className='text'>Cities <br></br>Served</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Counter